import * as Select from '@studio/design-system/select';
import { generateId } from '@studio/models';
import type { ReactElement } from 'react';
import { useMemo } from 'react';
import { twMerge } from 'cn';
import type { SelectionProps } from './types.js';

/** `<Selection>` component. */
export const Selection = ({
  available,
  className,
  onValueChange,
  selectedId,
  ...props
}: SelectionProps): ReactElement => {
  const [key, items] = useMemo(() => {
    /*
     * Force the select to re-render when the available devices change. Otherwise, I am getting:
     *
     * Uncaught DOMException: Node.removeChild: The node to be removed is not a child of this node
     */
    const uid = generateId();

    return [
      uid,
      <>
        {available.map((µ) => (
          <Select.Item key={µ.id} value={µ.id}>
            {µ.name}
          </Select.Item>
        ))}
      </>
    ];
  }, [available]);

  const title = useMemo(
    () => available.find((µ) => µ.id === selectedId)?.name,
    [available, selectedId]
  );

  const disabled = available.length === 0;

  return (
    <Select.Container
      className={twMerge(className, !disabled && '[&>label]:text-foreground')}
      label='Reference audio'
      {...props}
    >
      <Select.Root disabled={disabled} key={key} onValueChange={onValueChange} value={selectedId}>
        <Select.Trigger>
          <div className='overflow-hidden text-ellipsis [&_span]:whitespace-nowrap' title={title}>
            <Select.Value placeholder='None' />
          </div>
        </Select.Trigger>

        <Select.Content>{items}</Select.Content>
      </Select.Root>
    </Select.Container>
  );
};
